import './qrcodeGenerator.html';
import './qrcodeGenerator.scss';

//import { QRCode } from 'qrcode-svg/dist/qrcode.min';

import {inject, injectable} from "inversify";
import {wccModules} from "enums/wccModules";
import {Func} from "interfaces/func";
import { Observable } from 'knockout';

interface IQRCodeGeneratorConfig {
    QRCodeHeader: string 
    QRCodeSubHeader: string | undefined
    QRCodeSourceString: string | undefined 
    QRCodeSourceFn: Func<PromiseLike<string>> | undefined 
    QRCodeClassName: string | undefined
    QRCodeCopyLinkText: string | undefined
    QRCodeMakeSubHeaderInput: boolean | undefined;
    QRCodeUrl: Observable<string | undefined>;
}

const QRCode = require('qrcode-svg/dist/qrcode.min');
const _clipboard = require('Scripts/clipboard.2.0.0.min');

@injectable()
export default class QRCodeGenerator {
        
    busy = ko.observable(true);
    
    oQRCodeHeader = ko.observable('');
    oQRCodeSubHeader = ko.observable<string | undefined>();
    oQRCodeSubHeaderInput = ko.observable(false);
    oQRCodeData = ko.observable('');

    oQRCodeClassName = ko.observable();
    oQRCodeCopyLinkText = ko.observable('');

    qrCodeSourceString: string | undefined;
    qrCodeSourceFn: Func<PromiseLike<string>> | undefined;

    oHasQRCodeData = ko.pureComputed(() => this.oQRCodeData() != '');

    generateQRCode: Action;
    initClippy: (elements: HTMLElement[]) => void;
    selectQRCodeInput: (context: any, element: HTMLInputElement) => void;

    constructor(
        @inject(wccModules.componentConfig) private config: IQRCodeGeneratorConfig,
        @inject(wccModules.componentInfo) info: ko.components.ComponentInfo,
    ) {
        this.oQRCodeHeader(config.QRCodeHeader);
        this.oQRCodeSubHeader(config.QRCodeSubHeader);
        this.oQRCodeSubHeaderInput(config.QRCodeMakeSubHeaderInput ?? false);

        this.qrCodeSourceString = config.QRCodeSourceString;
        this.qrCodeSourceFn = config.QRCodeSourceFn;

        this.generateQRCode = async () => {
            let source = this.qrCodeSourceString;
            if(this.qrCodeSourceFn != undefined) {
                source = await this.qrCodeSourceFn();
                if (config.QRCodeUrl) {
                    config.QRCodeUrl(source);
                }
            }

            if (this.oQRCodeSubHeader() == undefined)
                this.oQRCodeSubHeader(source);

            let qrcode = new QRCode({
                content: source,
                container: "svg-viewbox", //Responsive use
                join: true //Crisp rendering and 4-5x reduced file size
            });
            this.oQRCodeData(qrcode.svg());

            this.oQRCodeClassName(config.QRCodeClassName);

            this.oQRCodeCopyLinkText(config.QRCodeCopyLinkText ?? 'Copy Link');

            this.busy(false);
        };

        this.initClippy = function (elements) {
            var target = $(elements[1]).find('.clippy-control');
            if (!target.length) {
                target = $(elements[1]).closest('.clippy-control');
            }
            new _clipboard(target[0])
                .on('success', () => WCC.System.showSuccessMessage('Link copied to clipboard!'))
                .on('error', () => WCC.System.showErrorMessage('An error happened. Select URL and use Ctrl+C instead.'));
        };

        this.selectQRCodeInput = (context: any, element: any) => {
            element?.target?.select();
        }
    }
}